import _classCallCheck from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
export var S3ExpressIdentityCacheEntry = /*#__PURE__*/function () {
  function S3ExpressIdentityCacheEntry(_identity) {
    var isRefreshing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var accessed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Date.now();
    _classCallCheck(this, S3ExpressIdentityCacheEntry);
    this._identity = _identity;
    this.isRefreshing = isRefreshing;
    this.accessed = accessed;
  }
  _createClass(S3ExpressIdentityCacheEntry, [{
    key: "identity",
    get: function get() {
      this.accessed = Date.now();
      return this._identity;
    }
  }]);
  return S3ExpressIdentityCacheEntry;
}();